import { createReducer, on } from '@ngrx/store';
import * as ImpersonationActions from './impersonation.actions';
import { initialImpersonationState } from './impersonation.state';

export const impersonationReducer = createReducer(
  initialImpersonationState,

  on(ImpersonationActions.initializeImpersonation, (state, { targetUserId, isConsultantImpersonation }) => ({
    ...state,
    targetUserId,
    isImpersonating: false,
    stopReason: null,
    isConsultantImpersonation: !!isConsultantImpersonation
  })),

  on(ImpersonationActions.stopImpersonation, (_, { reason }) => ({
    ...initialImpersonationState,
    stopReason: reason || null
  })),

  on(ImpersonationActions.setImpersonationSuccess, (state, { accessExpiresDateTime, accessScope, originalUserId }) => ({
    ...state,
    isImpersonating: true,
    accessExpiresDateTime,
    accessScope,
    originalUserId,
    stopReason: null
  })),

  on(ImpersonationActions.setImpersonationFailed, (state, { reason }) => ({
    ...state,
    isImpersonating: false,
    accessExpiresDateTime: null,
    accessScope: null,
    stopReason: reason
  }))
);
